import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Users, Lock, Unlock, Copy, Share2 } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Wallet card: shows invite requirement for the next withdrawal + invite link. */
export default function WithdrawGateCard({ refreshKey }) {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => { axios.get(`${API}/wallet/withdraw-gate`).then((r) => setSt(r.data)).catch(() => {}); }, [refreshKey]);
  if (!st || !st.enabled || st.required === 0) return null;
  const link = `${window.location.origin}/?ref=${user?.user_id}`;
  const pct = Math.min(100, Math.round((st.invited / Math.max(1, st.required)) * 100));
  const share = async () => {
    const text = `Entre no FUTURO PDV pelo meu convite: ${link}`;
    try { if (navigator.share) await navigator.share({ title: "FUTURO PDV", text, url: link }); else { await navigator.clipboard.writeText(link); toast.success("Link de convite copiado!"); } } catch { /* cancelled */ }
  };
  return (
    <Card className={`p-4 ${st.allowed ? "border-emerald-500/40 bg-emerald-500/5" : "border-amber-500/40 bg-amber-500/5"}`} data-testid="withdraw-gate-card">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${st.allowed ? "bg-emerald-500/15 text-emerald-600" : "bg-amber-500/15 text-amber-600"}`}>{st.allowed ? <Unlock className="w-5 h-5" /> : <Lock className="w-5 h-5" />}</div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm" data-testid="withdraw-gate-title">
            {st.allowed ? `${st.next_withdrawal_number}º saque liberado` : `${st.next_withdrawal_number}º saque: faltam ${st.missing} convidado${st.missing === 1 ? "" : "s"}`}
          </div>
          <p className="text-xs text-muted-foreground mt-0.5">Você convidou <b data-testid="withdraw-gate-invited">{st.invited}</b> de <b data-testid="withdraw-gate-required">{st.required}</b> amigos necessários para este saque.</p>
          <div className="h-2 rounded-full bg-muted mt-2 overflow-hidden"><div className={`h-full rounded-full transition-all ${st.allowed ? "bg-emerald-500" : "bg-amber-500"}`} style={{ width: `${pct}%` }} /></div>
          <div className="flex flex-wrap gap-2 mt-3">
            <Button size="sm" className="rounded-full h-8" onClick={share} data-testid="withdraw-gate-share"><Share2 className="w-3.5 h-3.5 mr-1" /> Convidar amigos</Button>
            <Button size="sm" variant="outline" className="rounded-full h-8" onClick={() => { navigator.clipboard?.writeText(link); toast.success("Link copiado!"); }} data-testid="withdraw-gate-copy"><Copy className="w-3.5 h-3.5 mr-1" /> Copiar link</Button>
          </div>
          <p className="text-[10px] text-muted-foreground mt-2 flex items-center gap-1"><Users className="w-3 h-3" /> Próximos: {st.ladder.filter((l) => l.n > st.next_withdrawal_number).slice(0, 3).map((l) => `${l.n}º = ${l.required}`).join(" · ")}</p>
        </div>
      </div>
    </Card>
  );
}
